import React from 'react';
import { Component, Position } from "puzzle"
import { Checkbox } from "@progress/kendo-react-inputs";

type STATE = {
  checked: boolean
}

type PROPS = {
  actionName: 'promote' | 'demote',
  previousPhase: string,
  showCheckbox: boolean
}

class ActionCannotBeRevertedWarning extends Component<PROPS, STATE> {
  public state = {
    checked: false
  };

  /**
   * @inheritDoc
   */
  moduleDidMount = () => {
    const { showCheckbox } = this.props;
    if (!showCheckbox) {
      this.dispatch('actionCannotBeRevertedWarningCompleteButton', Position.end, { buttonDisabled: !showCheckbox })
    }
  };

  /**
   * On checkbox change handler
   * @param e
   */
  onChange = (e: any) => {
    const { value } = e;
    this.setState({
        checked: value
      },
      () => this.dispatch('actionCannotBeRevertedWarningCompleteButton', '', { buttonDisabled: this.state.checked })
    );
  };

  renderBody = () => {
    const { checked } = this.state;
    const {
      actionName,
      showCheckbox,
      previousPhase
    } = this.props;

    return (
      <div className={'tp-warning-text'}>
        <span>
          <div className={'tp-font-size-md tp-text-semibold tp-dialog-subtitle'}>
          {this.translate('subTitle')}
        </div>
          {
            this.translate(`${actionName}Text`, {
              className: 'tp-text-semibold',
              previousPhase
            })
          }
          {showCheckbox &&
            <div className={'tp-checkbox-container'}>
              <Checkbox
                checked={checked}
                label={this.translate('cbText')}
                onChange={this.onChange}
              />
            </div>
          }
        </span>
      </div>
    )
  }
}

export default ActionCannotBeRevertedWarning;


